'use client'
import { cn } from '../../helpers/utils.js'
import type { Img } from '../../types/props.js'
import { withLayout } from '../../shared/Styles.js'
import { Text, Link } from '../../components/index.js'

export type DownLoadDataType = {
  title: string
  text: string
  time: string
  link: string
  line: Img
  icon: Img
}

interface DownLoadType extends React.HTMLAttributes<HTMLDivElement> {
  data: {
    list: DownLoadDataType[]
  }
}

const DownLoad = ({ data, className, ...rest }: DownLoadType) => {
  const { list } = data

  return (
    <>
      <div {...rest} className={cn('rounded-box flex w-full flex-col gap-[12px] bg-[#EAEAEC] p-[12px]', className)}>
        {list?.map((item, index) => (
          <div key={index} className="w-full">
            <Link
              href={item?.link}
              target="_blank"
              className="flex w-full items-center justify-between px-[24px] py-[12px]"
            >
              <div className="laptop:gap-[24px] flex flex-row items-center gap-[12px]">
                <Text html={item?.title} className="laptop:text-[16px] text-[14px] font-bold leading-[1.4]" />
                {/* <Picture
                className="h-[16px]"
                source={item.line?.url}
                alt={item.line?.alt || ''}
              /> */}
                {item?.text && (
                  <svg xmlns="http://www.w3.org/2000/svg" width="2" height="17" viewBox="0 0 2 17" fill="none">
                    <path d="M1 0.5V16.5" stroke="#3D3D3F" />
                  </svg>
                )}
                <Text html={item?.text} className="laptop:text-[16px] text-[14px] font-bold leading-[1.4]" />
              </div>

              {/* <Link
              href={item?.link}
              target="_blank"
            > */}
              <div className="laptop:gap-[24px] flex flex-row items-center justify-center gap-[4px]">
                <Text html={item?.time} className="laptop:text-[16px] text-[14px] font-bold leading-[1.4]" />
                {/* <Picture
                  className="w-[24px]"
                  imgClassName="w-full h-auto"
                  source={item.icon?.url}
                  alt={item.icon?.alt || ''}
                /> */}
                <svg
                  className="icon"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="25"
                  viewBox="0 0 24 25"
                  fill="none"
                >
                  <path
                    d="M21 11.5C21.5523 11.5 22 11.9477 22 12.5V18.5C22 20.1569 20.6569 21.5 19 21.5H5C3.34315 21.5 2 20.1569 2 18.5V12.5C2 11.9477 2.44772 11.5 3 11.5C3.55228 11.5 4 11.9477 4 12.5V18.5C4 19.0523 4.44772 19.5 5 19.5H19C19.5523 19.5 20 19.0523 20 18.5V12.5C20 11.9477 20.4477 11.5 21 11.5ZM12.0039 2.25391C12.5562 2.25391 13.0039 2.70162 13.0039 3.25391V13.4736L16.4893 9.98828C16.8798 9.59777 17.5128 9.59779 17.9033 9.98828C18.2938 10.3788 18.2938 11.0118 17.9033 11.4023L13.4541 15.8516C12.6471 16.6583 11.3392 16.6582 10.5322 15.8516L6.08984 11.4092C5.69932 11.0187 5.69932 10.3856 6.08984 9.99512C6.48037 9.60466 7.11341 9.60462 7.50391 9.99512L11.0039 13.4951V3.25391C11.0039 2.70162 11.4516 2.25391 12.0039 2.25391Z"
                    fill="currentColor"
                  />
                </svg>
              </div>

              {/* </Link> */}
            </Link>
          </div>
        ))}
      </div>
    </>
  )
}

export default withLayout(DownLoad)
